import React, { useEffect, useMemo, useState, useCallback } from "react";
import Navbar from '../Navbar/Navbar.jsx';
import TopBar from '../Navbar/Mainbar.jsx';
const getBackendUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (process.env.NODE_ENV === "production") return "https://api.leave-management.manurevasolutions.com";
  return "http://localhost:5000";
};
const BASE = getBackendUrl();
const API = `${BASE}/api/attendance/admin`;
console.log("API =", API);

const useWindowSize = () => {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return w;
};

const STATUS = {
  on_time:      { label: "OK",          color: "#15803d", bg: "#dcfce7", rail: "#22c55e" },
  soft_late:    { label: "Soft-late",   color: "#b45309", bg: "#fef3c7", rail: "#f59e0b" },
  missed_core:  { label: "Missed-core", color: "#b91c1c", bg: "#fee2e2", rail: "#ef4444" },
  short_hours:  { label: "Short",       color: "#c2410c", bg: "#ffedd5", rail: "#f97316" },
  needs_review: { label: "Review",      color: "#4b5563", bg: "#e5e7eb", rail: "#9ca3af" },
  absent:       { label: "Absent",      color: "#c0392b", bg: "#fdeeee", rail: "#dc2626" },
  neutral:      { label: "Leave / off", color: "#8a8f98", bg: "#f1f2f4", rail: "#cbd0d6" },
  wfh:          { label: "WFH",         color: "#1d4ed8", bg: "#e8f0fe", rail: "#2563eb" },
};
const EXCEPTION = new Set(["missed_core", "short_hours", "needs_review"]);

async function apiGet(path) {
  const r = await fetch(API + path, { credentials: "include" });
  if (r.status === 403) throw { forbidden: true };
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || `HTTP ${r.status}`);
  return r.json();
}
// async function apiPost(path, body) {
//   const r = await fetch(API + path, {
//     method: "POST", credentials: "include",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body || {}),
//   });
//   if (r.status === 403) throw { forbidden: true };
//   if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || `HTTP ${r.status}`);
//   return r.json();
// }


async function apiPost(path, body) {
  const r = await fetch(API + path, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (r.status === 403) throw { forbidden: true };
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    const err = new Error(j.error || `HTTP ${r.status}`);
    err.status = r.status;
    err.data = j;
    throw err;
  }
  return r.json();
}


const Swal = () => (typeof window !== "undefined" ? window.Swal : null);
async function confirmAction(title, text, confirmText) {
  const s = Swal();
  if (s) {
    const res = await s.fire({ title, text, icon: "question", showCancelButton: true,
      confirmButtonText: confirmText, confirmButtonColor: "#101F40" });
    return res.isConfirmed;
  }
  return window.confirm(`${title}\n\n${text}`);
}
async function promptNote(title) {
  const s = Swal();
  if (s) {
    const res = await s.fire({ title, input: "text", inputLabel: "Note (optional)",
      showCancelButton: true, confirmButtonColor: "#101F40" });
    return res.isConfirmed ? (res.value || "") : null;
  }
  const v = window.prompt(title);
  return v === null ? null : v;
}
function toast(msg, ok = true) {
  const s = Swal();
  if (s) s.fire({ toast: true, position: "top-end", timer: 2200, showConfirmButton: false,
    icon: ok ? "success" : "error", title: msg });
}

function StatusPill({ status }) {
  const s = STATUS[status] || STATUS.neutral;
  return <span className="att-pill" style={{ color: s.color, background: s.bg }}>{s.label || status}</span>;
}

function PunchChain({ punches, issues }) {
  const errors = issues?.errors || [];
  const notes = issues?.notes || [];
  const bad = new Set(issues?.bad_idx || []);
  if ((!punches || punches.length <= 2) && errors.length === 0 && notes.length === 0) return null;
  const cls = (d) => (d === "in" ? "att-punch--in" : d === "out" ? "att-punch--out" : "att-punch--unk");
  const lbl = (d) => (d === "in" ? "IN" : d === "out" ? "OUT" : "?");
  return (
    <div className="att-punchwrap">
      <div className="att-punches">
        {(punches || []).map((p, i) => (
          <span key={i} className={`att-punch ${cls(p.dir)} ${bad.has(i) ? "att-punch--bad" : ""}`}>
            <span className="att-punch__k">{lbl(p.dir)}</span>{p.time}
          </span>
        ))}
      </div>
      
    </div>
  );
}

function Forbidden() {
  return (
    <div className="att-wrap">
      <div className="att-card att-forbidden">
        <h3>Attendance admin only</h3>
        <p>This console is limited to HR, CEO and Superadmin roles. If you need access,
          ask a Superadmin to adjust your portal role.</p>
      </div>
    </div>
  );
}

/* ===================== Tab 1 — Day dashboard ===================== */
const CHIPS = [
  { key: "all", label: "All" },
  { key: "missed_core", label: "Missed-core" },
  { key: "short_hours", label: "Short" },
  { key: "needs_review", label: "Review" },
  { key: "ok", label: "OK" },
];
const CHIP_MATCH = {
  all: null, missed_core: ["missed_core"], short_hours: ["short_hours"],
  needs_review: ["needs_review"], ok: ["on_time", "soft_late"],
};

function DayDashboard({ onForbidden }) {
  const [date, setDate] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chip, setChip] = useState("all");
  const [sort, setSort] = useState({ col: "in", dir: "asc" });
  const [openRow, setOpenRow] = useState({});

  const load = useCallback(async (d) => {
    setLoading(true);
    try {
      const res = await apiGet(`/day${d ? `?date=${d}` : ""}`);
      setData(res); setDate(res.date);
    } catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load day", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { load(""); }, [load]);

  const rows = useMemo(() => {
    if (!data) return [];
    let r = data.rows;
    const match = CHIP_MATCH[chip];
    if (match) r = r.filter((x) => match.includes(x.status));
    const { col, dir } = sort;
    const val = (x) => ({ Employee: x.employee, in: x.in, out: x.out,
      Duration: x.presence_min == null ? -1e9 : x.presence_min, Status: x.status }[col]);
    return [...r].sort((a, b) => {
      if (a.is_exception !== b.is_exception) return a.is_exception ? -1 : 1;
      const av = val(a), bv = val(b);
      const cmp = av < bv ? -1 : av > bv ? 1 : 0;
      return dir === "asc" ? cmp : -cmp;
    });
  }, [data, chip, sort]);

  const setCol = (col) => setSort((s) => ({ col, dir: s.col === col && s.dir === "asc" ? "desc" : "asc" }));
  const exportCsv = () => {
    window.open(`${API}/day?date=${date}&format=csv`, "_blank");
  };

  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;

  const cnt = data?.counts || {};
  const headline = [
    ["OK", cnt.ok, "on_time"], ["Soft-late", cnt.soft_late, "soft_late"],
    ["Missed-core", cnt.missed_core, "missed_core"], ["Short", cnt.short, "short_hours"],
    ["Review", cnt.review, "needs_review"], ["Absent", cnt.absent, "absent"],
  ];

  return (
    
    <div>

      <div className="att-toolbar">
        <input type="date" className="att-input" value={date} onChange={(e) => load(e.target.value)} />
        <button className="att-btn att-btn--ghost" onClick={exportCsv}>Export CSV</button>
        <span className="att-daylabel">
          {data?.date_label}{data?.defaulted_to_prev_wd ? " · previous working day" : ""}
        </span>
        <span className="att-scope">{data?.in_scope} in scope</span>
      </div>
      
      <div className="att-cluster">
        {headline.map(([label, n, key]) => {
          const s = STATUS[key];
          return (
            <div key={label} className={`att-stat ${(n ?? 0) === 0 ? "is-zero" : ""}`} style={{ "--rail": s.rail }}>
              <span className="att-stat__n" style={{ color: s.color }}>{n ?? 0}</span>
              <span className="att-stat__label">{label}</span>
            </div>
          );
        })}
      </div>

      <div className="att-chips">
        {CHIPS.map((ch) => (
          <button key={ch.key} onClick={() => setChip(ch.key)}
            className={`att-chip ${chip === ch.key ? "is-on" : ""}`}>{ch.label}</button>
        ))}
      </div>

      {data?.no_data ? (
        <div className="att-alert att-alert--bad">⚠ No data pulled for this date — check ingestion.</div>
      ) : (
        <div className="att-card att-tablecard">
          <table className="att-table">
            <thead>
              <tr>
                {["Employee", "In", "Out", "Duration", "Status"].map((h) => {
                  const col = h === "In" ? "in" : h === "Out" ? "out" : h;
                  const on = sort.col.toLowerCase() === col.toLowerCase();
                  return (
                    <th key={h} className={h === "Employee" ? "" : "num"} onClick={() => setCol(col)}>
                      {h}{on ? (sort.dir === "asc" ? " ▲" : " ▼") : ""}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                // WFH days come through as status "neutral" with day_class "WFH";
                // surface them as a distinct chip instead of generic "Leave / off".
                const statusKey = (r.status === "neutral" && r.day_class === "WFH") ? "wfh" : r.status;
                const s = STATUS[statusKey] || STATUS.neutral;
                const exc = r.is_exception ?? EXCEPTION.has(r.status);
                const pi = r.punch_issues || {};
                const hasErr = (pi.errors || []).length > 0;
                const hasNote = (pi.notes || []).length > 0;
                const canExpand = (r.punch_count > 2) || hasErr || hasNote;
                const isOpen = !!openRow[r.employee_id];
                return (
                  <React.Fragment key={r.employee_id}>
                  <tr className={exc ? "is-exc" : statusKey === "neutral" ? "is-mute" : ""}
                      style={{ ...(exc ? { "--rail": s.rail } : {}), cursor: canExpand ? "pointer" : "default" }}
                      onClick={canExpand ? () => setOpenRow((o) => ({ ...o, [r.employee_id]: !o[r.employee_id] })) : undefined}>
                    <td data-label="Employee" className="att-name">
                      {r.employee}
                      {hasErr && <span className="att-punchbadge att-punchbadge--err">⚠ punch issue</span>}
                      {!hasErr && hasNote && <span className="att-punchbadge att-punchbadge--note">⚠ check punches</span>}
                      {canExpand && <span className="att-rowchev">{isOpen ? " ▾" : " ▸"}</span>}
                    </td>
                    <td data-label="In" className="num">{r.in}</td>
                    <td data-label="Out" className="num">{r.out}</td>
                    <td data-label="Duration" className="num">{r.duration}</td>
                    <td data-label="Status">
                      <StatusPill status={statusKey} />
                      {r.source_status && r.source_status !== "device" && (
                        <span className="att-src">({r.source_status})</span>
                      )}
                    </td>
                  </tr>
                  {isOpen && canExpand && (
                    <tr className="att-punchrow">
                      <td colSpan={5}><PunchChain punches={r.punches} issues={r.punch_issues} /></td>
                    </tr>
                  )}
                  </React.Fragment>
                );
              })}
              {rows.length === 0 && <tr><td className="att-muted" colSpan={5}>No rows match this filter.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

/* ===================== Tab 2 — Monthly scorecard ===================== */
function MonthlyScorecard({ onForbidden }) {
  const now = new Date();
  const prev = new Date(now.getFullYear(), now.getMonth(), 0);
  const [ym, setYm] = useState(`${prev.getFullYear()}-${String(prev.getMonth() + 1).padStart(2, "0")}`);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState({});

  const load = useCallback(async (val) => {
    setLoading(true);
    const [y, m] = val.split("-");
    try { setData(await apiGet(`/scorecard?year=${y}&month=${parseInt(m, 10)}`)); }
    catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load scorecard", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { load(ym); }, []); // eslint-disable-line

  const exportCsv = () => {
    const [y, m] = ym.split("-");
    window.open(`${API}/scorecard?year=${y}&month=${parseInt(m, 10)}&format=csv`, "_blank");
  };

  const band = (s) => (s == null ? "na" : s >= 85 ? "good" : s >= 65 ? "mid" : "low");
  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;

  return (
    <div>
      <div className="att-toolbar">
        <input type="month" className="att-input" value={ym}
          onChange={(e) => { setYm(e.target.value); load(e.target.value); }} />
        <button className="att-btn att-btn--ghost" onClick={exportCsv}>Export CSV</button>
        <span className="att-note">Sorted lowest score first · {data?.note || "admin only — not a team ranking"}</span>
      </div>

      <div className="att-card att-tablecard">
        <table className="att-table att-table--score">
          <thead>
            <tr>
              <th style={{ width: 28 }}></th>
              <th>Employee</th>
              <th className="num">Score</th>
              <th>Components</th>
              <th className="num">Days</th>
            </tr>
          </thead>
          <tbody>
            {(data?.rows || []).map((r) => {
              const isOpen = !!open[r.employee_id];
              return (
                <React.Fragment key={r.employee_id}>
                  <tr className="att-scorerow" onClick={() => setOpen((o) => ({ ...o, [r.employee_id]: !o[r.employee_id] }))}>
                    <td className="att-chevron">{isOpen ? "▾" : "▸"}</td>
                    <td data-label="Employee" className="att-name">{r.employee}</td>
                    <td data-label="Score" className="num">
                      <span className={`att-score att-score--${band(r.score)}`}>{r.score == null ? "N/A" : r.score}</span>
                    </td>
                    <td data-label="Components" className="att-comp">
                      {(r.components || []).map((c, i) => <span key={i} className="att-comp__item">{c}</span>)}
                    </td>
                    <td data-label="Days" className="num">{r.working_days}</td>
                  </tr>
                  {isOpen && (
                    <tr className="att-detailrow">
                      <td></td>
                      <td colSpan={4}>
                        <table className="att-table att-table--inner">
                          <thead>
                            <tr>{["Date", "In", "Out", "Duration", "Status", "−"].map((h) =>
                              <th key={h} className={h === "Date" ? "" : "num"}>{h}</th>)}</tr>
                          </thead>
                          <tbody>
                            {r.days.map((d) => (
                              <React.Fragment key={d.work_date}>
                                <tr>
                                  <td data-label="Date">
                                    {d.work_date}
                                    {d.punch_count > 2 && (
                                      <span className="att-punchbadge">{d.punch_count} punches</span>
                                    )}
                                    {(d.punch_issues?.errors || []).length > 0 && (
                                      <span className="att-punchbadge att-punchbadge--err">⚠ issue</span>
                                    )}
                                    {(d.punch_issues?.errors || []).length === 0 &&
                                     (d.punch_issues?.notes || []).length > 0 && (
                                      <span className="att-punchbadge att-punchbadge--note">⚠ check</span>
                                    )}
                                  </td>
                                  <td data-label="In" className="num">{d.in}</td>
                                  <td data-label="Out" className="num">{d.out}</td>
                                  <td data-label="Duration" className="num">{d.duration}</td>
                                  <td data-label="Status"><StatusPill status={d.status} /></td>
                                  <td data-label="−" className="num" style={{ color: d.deduction ? "#c0392b" : "#8a8f98" }}>
                                    {d.deduction || ""}
                                  </td>
                                </tr>
                                {d.punches && d.punches.length > 2 && (
                                  <tr className="att-punchrow">
                                    <td></td>
                                    <td colSpan={5}><PunchChain punches={d.punches} issues={d.punch_issues} /></td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ===================== Tab 3 — Corrections queue ===================== */
function CorrectionsQueue({ onForbidden, onCountChange }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiGet(`/corrections?state=pending`);
      setData(res); onCountChange?.(res.pending_count);
    } catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load queue", false);
    } finally { setLoading(false); }
  }, [onForbidden, onCountChange]);

  useEffect(() => { load(); }, [load]);

  const approve = async (c) => {
    const ok = await confirmAction("Approve correction?",
      `${c.employee} · ${c.work_date}\nApply ${c.proposed_in}–${c.proposed_out} and recompute the day.`, "Approve");
    if (!ok) return;
    setBusy(c.id);
    try {
      const res = await apiPost(`/corrections/${c.id}/approved`);
      toast(`Approved — day is now ${STATUS[res.day?.status]?.label || res.day?.status || "recomputed"}`);
      await load();
    } catch (e) { toast(e.message || "Approve failed", false); } finally { setBusy(null); }
  };
  const reject = async (c) => {
    const note = await promptNote(`Reject correction for ${c.employee} · ${c.work_date}?`);
    if (note === null) return;
    setBusy(c.id);
    try { await apiPost(`/corrections/${c.id}/rejected`, { note }); toast("Rejected"); await load(); }
    catch (e) { toast(e.message || "Reject failed", false); } finally { setBusy(null); }
  };

  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;
  const rows = data?.corrections || [];

  if (rows.length === 0)
    return <div className="att-empty"><div className="att-empty__mark">✓</div>
      <p><strong>Queue clear.</strong> No corrections waiting for review.</p></div>;

  return (
    <div className="att-corrlist">
      {rows.map((c) => (
        <div key={c.id} className={`att-card att-corr ${c.over_48h ? "is-risk" : ""}`}>
          <div className="att-corr__who">
            <strong>{c.employee}</strong>
            <span className="att-corr__date">{c.work_date}</span>
            {c.over_48h && <span className="att-corr__risk">{Math.floor(c.age_hours)}h · penalty risk</span>}
          </div>
          <div className="att-corr__times">
            <div className="att-corr__col"><span className="k">Recorded</span>
              <span className="v v--strike">{c.current_in}–{c.current_out}</span></div>
            <span className="att-corr__arrow">→</span>
            <div className="att-corr__col"><span className="k">Proposed</span>
              <span className="v">{c.proposed_in}–{c.proposed_out}</span></div>
            <div className="att-corr__col att-corr__col--reason"><span className="k">Reason</span>
              <span className="v v--reason">{c.reason}</span></div>
          </div>
          <div className="att-corr__actions">
            <button className="att-btn att-btn--approve" disabled={busy === c.id} onClick={() => approve(c)}>Approve</button>
            <button className="att-btn att-btn--reject" disabled={busy === c.id} onClick={() => reject(c)}>Reject</button>
          </div>
        </div>
      ))}
    </div>
  );
}

/* ===================== Tab 4 — Leave details ===================== */
/* Pick a month → blue columns show ONLY that month,
   balance columns show 1 Jan → end of that month.                    */
const LD_MONTHS_LONG  = ["January","February","March","April","May","June",
                         "July","August","September","October","November","December"];
const LD_MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const LD_START_YEAR   = 2026; // portal's first year — no data before this

function LeaveDetails({ onForbidden }) {
  const now = new Date();
  const cy = now.getFullYear();
  const cm = now.getMonth() + 1;

  // month options, newest first: "October 2026 (so far)", "September 2026", …
  const monthOptions = useMemo(() => {
    const out = [];
    for (let y = cy; y >= LD_START_YEAR; y--) {
      for (let m = (y === cy ? cm : 12); m >= 1; m--) {
        out.push({
          value: `${y}-${m}`,
          label: `${LD_MONTHS_LONG[m - 1]} ${y}${y === cy && m === cm ? " (so far)" : ""}`,
        });
      }
    }
    return out;
  }, [cy, cm]);

  // default = last completed month (in January: January so far)
  const [picked, setPicked] = useState(cm > 1 ? `${cy}-${cm - 1}` : `${cy}-1`);
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [q, setQ]             = useState("");

  const [year, month] = picked.split("-").map(Number);
  const mShort = LD_MONTHS_SHORT[month - 1];
  const mLong  = LD_MONTHS_LONG[month - 1];

  const load = useCallback(async (y, m) => {
    setLoading(true);
    try { setData(await apiGet(`/leave-summary?year=${y}&month=${m}`)); }
    catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load leave details", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { load(year, month); }, [year, month, load]);

  const rows = useMemo(() => {
    const list = data?.rows || [];
    const needle = q.trim().toLowerCase();
    if (!needle) return list;
    return list.filter(
      (r) => r.employee.toLowerCase().includes(needle) ||
             (r.email || "").toLowerCase().includes(needle)
    );
  }, [data, q]);

  // ‹ older / newer ›
  const idx = monthOptions.findIndex((o) => o.value === picked);
  const canOlder = idx < monthOptions.length - 1;
  const canNewer = idx > 0;
  const goOlder = () => canOlder && setPicked(monthOptions[idx + 1].value);
  const goNewer = () => canNewer && setPicked(monthOptions[idx - 1].value);

  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;

  const t = data?.totals || {};
  const hoursEach = data?.policy?.permission_hours_each ?? 2;
  const asOf = data?.window?.end
    ? new Date(data.window.end + "T00:00:00").toLocaleDateString("en-GB",
        { day: "2-digit", month: "short", year: "numeric" })
    : "";

  // remaining pill colours — green = balance left, red = over-used (LOP)
  const remStyle = (v) => ({
    marginLeft: 8,
    color: v < 0 ? "#b91c1c" : "#15803d",
    background: v < 0 ? "#fee2e2" : "#dcfce7",
  });
  const remText = (v) => (v < 0 ? v : `+${v}`);
  const ofStyle = { color: "#8a8f98", fontWeight: 400, marginLeft: 4 };

  // month-only columns get a light blue tint so they stand out
  const monthTh   = { color: "#2563eb" };
  const monthTd   = { background: "#f7f9ff" };
  const monthVal  = (v) => (Number(v) > 0
    ? <strong>{v}</strong>
    : <span style={{ color: "#b6bcc6" }}>–</span>);

  const navBtn = (enabled) => ({
    width: 34, height: 34, borderRadius: 8, border: "1px solid #d7dbe0",
    background: "#fff", fontSize: 16, lineHeight: "16px",
    color: enabled ? "#1f2937" : "#b6bcc6",
    cursor: enabled ? "pointer" : "not-allowed",
  });

  return (
    <div>
      <div className="att-toolbar">
        <button type="button" aria-label="Previous month" onClick={goOlder}
                disabled={!canOlder} style={navBtn(canOlder)}>‹</button>

        <select className="att-input" aria-label="Month" value={picked}
                onChange={(e) => setPicked(e.target.value)}
                style={{ fontWeight: 600, minWidth: 190 }}>
          {monthOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>

        <button type="button" aria-label="Next month" onClick={goNewer}
                disabled={!canNewer} style={navBtn(canNewer)}>›</button>

        <span className="att-daylabel">
          {data?.is_running
            ? `${mLong} so far · balance as of ${asOf}`
            : `Leave in ${mLong} ${year} · balance as of ${asOf}`}
          {loading ? " · loading…" : ""}
        </span>
        <span className="att-scope">{data?.in_scope} in scope</span>
      </div>

      {/* <div className="att-cluster" style={{ gridTemplateColumns: "repeat(4,1fr)" }}>
        {stats.map(([label, val, rail]) => (
          <div key={label} className="att-stat" style={{ "--rail": rail }}>
            <span className="att-stat__n" style={{ color: rail }}>{val}</span>
            <span className="att-stat__label">{label}</span>
          </div>
        ))}
      </div> */}

      <div className="att-toolbar">
        <input className="att-input" placeholder="Search employee…" value={q}
          onChange={(e) => setQ(e.target.value)} style={{ minWidth: 260 }} />
      </div>

      <div className="att-card att-tablecard">
        <div className="att-ldscroll">
        <table className="att-table att-ldtable">
          <thead>
            <tr>
              <th>Employee</th>
              <th className="num" style={monthTh}>EL taken · {mShort}</th>
              <th className="num">EL balance · end {mShort}</th>
              <th className="num" style={monthTh}>SL taken · {mShort}</th>
              <th className="num">SL balance · end {mShort}</th>
              <th className="num" style={monthTh}>Permission · {mShort}</th>
              <th className="num" style={monthTh}>Absent · {mShort}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.employee_id}>
                <td data-label="Employee" className="att-name">
                  {r.employee}
                  {r.email
                    ? <span className="att-src">{r.email}</span>
                    : (!r.linked ? <span className="att-src">no portal account</span> : null)}
                </td>

                {/* EL — this month only */}
                <td data-label={`EL ${mShort}`} className="num" style={monthTd}>
                  {monthVal(r.el.taken_month)}
                </td>
                {/* EL — balance at month end */}
                <td data-label="EL balance" className="num">
                  <strong>{r.el.taken}</strong>
                  <span style={ofStyle}>/ {r.el.entitled}</span>
                  <span className="att-pill" style={remStyle(r.el.remaining)}>{remText(r.el.remaining)}</span>
                </td>

                {/* SL — this month only */}
                <td data-label={`SL ${mShort}`} className="num" style={monthTd}>
                  {monthVal(r.sl.taken_month)}
                </td>
                {/* SL — balance at month end */}
                <td data-label="SL balance" className="num">
                  <strong>{r.sl.taken}</strong>
                  <span style={ofStyle}>/ {r.sl.entitled}</span>
                  <span className="att-pill" style={remStyle(r.sl.remaining)}>{remText(r.sl.remaining)}</span>
                </td>

                {/* Permission — this month only */}
                <td data-label="Permission" className="num" style={monthTd}>
                  <strong>{r.permission.taken_count}</strong>
                  <span style={ofStyle}>/ {r.permission.entitled_count}</span>
                  {r.permission.taken_hours > 0 && (
                  <span style={{ color: "#7c3aed", fontWeight: 600, marginLeft: 8, fontSize: 12 }}>
                    {r.permission.taken_hours}h
                  </span>
                  )}
                </td>

                {/* Absent — this month only */}
                <td data-label="Absent" className="num" style={monthTd}>
                  <strong style={{ color: r.absent_month > 0 ? "#c0392b" : "#8a8f98" }}>
                    {r.absent_month ?? 0}
                  </strong>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td className="att-muted" colSpan={7}>
                {q ? `No employees match “${q}”.` : `No employees in scope for ${mLong} ${year}.`}
              </td></tr>
            )}
          </tbody>
        </table>
        </div>
      </div>

      
    </div>
  );
}

/* ===================== Tab — Work from home ===================== */
const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const fmtDay = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

function WorkFromHome({ onForbidden }) {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [userId, setUserId] = useState("");
  const [mode, setMode] = useState("single"); // single | range
  const [start, setStart] = useState(todayIso());
  const [end, setEnd] = useState(todayIso());
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [scope, setScope] = useState("upcoming");
  const [list, setList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const loadUsers = useCallback(async () => {
    try { setUsers((await apiGet(`/wfh/users`)).users || []); }
    catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load employees", false);
    }
  }, [onForbidden]);

  const loadList = useCallback(async (sc) => {
    setLoading(true);
    try { setList((await apiGet(`/wfh?scope=${sc}`)).rows || []); }
    catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load WFH list", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { loadUsers(); }, [loadUsers]);
  useEffect(() => { loadList(scope); }, [scope, loadList]);

  const filteredUsers = useMemo(() => {
    const n = search.trim().toLowerCase();
    if (!n) return users;
    return users.filter((u) =>
      (u.name || "").toLowerCase().includes(n) ||
      (u.email || "").toLowerCase().includes(n) ||
      (u.employee_code || "").toLowerCase().includes(n));
  }, [users, search]);

  const selected = users.find((u) => String(u.id) === String(userId));
  const endDate = mode === "single" ? start : end;

const submit = async () => {
  setError("");
  if (!userId) return setError("Choose an employee.");
  if (!start) return setError("Choose a date.");
  if (mode === "range" && (!end || end < start)) return setError("End date must be on or after the start date.");

  const when = mode === "single" ? fmtDay(start) : `${fmtDay(start)} to ${fmtDay(endDate)}`;
  const ok = await confirmAction("Assign work from home?", `${selected?.name} · ${when}`, "Assign WFH");
  if (!ok) return;

  const send = (replace) => apiPost(`/wfh`, {
    user_id: Number(userId), start_date: start, end_date: endDate, reason,
    replace_leaves: replace,
  });

  setSaving(true);
  try {
    let res;
    try {
      res = await send(false);
    } catch (e) {
      if (e.status !== 409 || !e.data?.conflicts) throw e;

      const list = e.data.conflicts
        .map((c) => `${fmtDay(c.date)} (${c.leave_type})`)
        .join(", ");
      const convert = await confirmAction(
        "Leave already exists",
        `${selected?.name} already has leave on ${list}. Convert it to WFH?`,
        "Convert to WFH"
      );
      if (!convert) return;
      res = await send(true);
    }

    let msg = `WFH assigned · ${res.working_days} working day${res.working_days === 1 ? "" : "s"}`;
    if (res.converted_days) msg += ` · ${res.converted_days} leave converted`;
    if (res.recomputed_days) msg += ` · ${res.recomputed_days} recomputed`;
    toast(msg);
    setReason(""); setUserId(""); setSearch("");
    await loadList(scope);
  } catch (e) {
    if (e.forbidden) return onForbidden();
    setError(e.message || "Could not assign WFH");
  } finally { setSaving(false); }
};

  const cancel = async (w) => {
    const when = w.single_day ? fmtDay(w.start_date) : `${fmtDay(w.start_date)} to ${fmtDay(w.end_date)}`;
    const note = await promptNote(`Cancel WFH for ${w.employee} · ${when}?`);
    if (note === null) return;
    setBusy(w.id);
    try {
      const res = await apiPost(`/wfh/${w.id}/cancel`, { note });
      toast(res.recomputed_days ? `WFH cancelled · ${res.recomputed_days} day(s) recomputed` : "WFH cancelled");
      await loadList(scope);
    } catch (e) { toast(e.message || "Cancel failed", false); } finally { setBusy(null); }
  };

  return (
    <div>
      <div className="att-card att-wfhform">
        <div className="att-field att-field--emp">
          <label className="att-label" htmlFor="wfh-search">Employee</label>
          <input id="wfh-search" className="att-input" placeholder="Search name, email or ID…"
            value={search} onChange={(e) => setSearch(e.target.value)} />
          <select className="att-input" size={6} value={userId}
            onChange={(e) => setUserId(e.target.value)} aria-label="Employee list">
            {filteredUsers.map((u) => (
              <option key={u.id} value={u.id}>
                {u.name}{u.employee_code ? ` (${u.employee_code})` : ""}{u.linked ? "" : " — no device link"}
              </option>
            ))}
          </select>
          {filteredUsers.length === 0 && <span className="att-hint">No employees match “{search}”.</span>}
          {selected && !selected.linked && (
            <span className="att-hint att-hint--warn">
              Not linked to a device employee — WFH is saved but won’t change attendance scoring.
            </span>
          )}
        </div>

        <div className="att-field">
          <span className="att-label">Dates</span>
          <div className="att-seg" role="radiogroup" aria-label="Date mode">
            <button type="button" role="radio" aria-checked={mode === "single"}
              className={`att-seg__btn ${mode === "single" ? "is-on" : ""}`} onClick={() => setMode("single")}>Single day</button>
            <button type="button" role="radio" aria-checked={mode === "range"}
              className={`att-seg__btn ${mode === "range" ? "is-on" : ""}`} onClick={() => setMode("range")}>Date range</button>
          </div>
          <div className="att-daterow">
            <label className="att-sub">
              {mode === "single" ? "Date" : "From"}
              <input type="date" className="att-input" value={start}
                onChange={(e) => { setStart(e.target.value); if (end < e.target.value) setEnd(e.target.value); }} />
            </label>
            {mode === "range" && (
              <label className="att-sub">To
                <input type="date" className="att-input" value={end} min={start}
                  onChange={(e) => setEnd(e.target.value)} />
              </label>
            )}
          </div>
          <span className="att-hint">Week-offs and holidays in the range are skipped automatically.</span>

          <label className="att-label" htmlFor="wfh-reason" style={{ marginTop: 10 }}>Reason (optional)</label>
          <input id="wfh-reason" className="att-input" value={reason} maxLength={300}
            placeholder="e.g. Client call from home" onChange={(e) => setReason(e.target.value)} />

          {error && <div className="att-formerr">{error}</div>}
          <div>
            <button className="att-btn att-btn--primary" disabled={saving} onClick={submit}>
              {saving ? "Assigning…" : "Assign WFH"}
            </button>
          </div>
        </div>
      </div>

      <div className="att-toolbar" style={{ marginTop: 20 }}>
        <div className="att-chips" style={{ margin: 0 }}>
          <button className={`att-chip ${scope === "upcoming" ? "is-on" : ""}`} onClick={() => setScope("upcoming")}>Current & upcoming</button>
          <button className={`att-chip ${scope === "past" ? "is-on" : ""}`} onClick={() => setScope("past")}>Past 120 days</button>
        </div>
        <span className="att-scope">{list ? `${list.length} assignment${list.length === 1 ? "" : "s"}` : ""}</span>
      </div>

      {loading && !list ? <p className="att-muted att-pad">Loading…</p> : (
        <div className="att-card att-tablecard">
          <table className="att-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Dates</th>
                <th className="num">Days</th>
                <th>Reason</th>
                <th>Assigned by</th>
                {scope === "upcoming" && <th></th>}
              </tr>
            </thead>
            <tbody>
              {(list || []).map((w) => (
                <tr key={w.id}>
                  <td data-label="Employee" className="att-name">
                    {w.employee}
                    {!w.linked && <span className="att-src">no device link</span>}
                  </td>
                  <td data-label="Dates">
                    {w.single_day ? fmtDay(w.start_date) : `${fmtDay(w.start_date)} – ${fmtDay(w.end_date)}`}
                  </td>
                  <td data-label="Days" className="num">{w.days}</td>
                  <td data-label="Reason" className="att-wfhreason">{w.reason || "—"}</td>
                  <td data-label="Assigned by">{w.assigned_by || "Employee request"}</td>
                  {scope === "upcoming" && (
                    <td data-label="">
                      <button className="att-btn att-btn--reject" disabled={busy === w.id} onClick={() => cancel(w)}>Cancel</button>
                    </td>
                  )}
                </tr>
              ))}
              {(list || []).length === 0 && (
                <tr><td className="att-muted" colSpan={6}>
                  {scope === "upcoming" ? "No WFH scheduled. Assign one above." : "No WFH in the last 120 days."}
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}



/* ===================== Tab — Today (live, raw punches, no scoring) ===================== */
function LiveToday({ onForbidden }) {
  const [date, setDate] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (d) => {
    setLoading(true);
    try {
      const res = await apiGet(`/live-punches${d ? `?date=${d}` : ""}`);
      setData(res); setDate(res.date);
    } catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load live view", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { load(""); }, [load]);

  const cls = (d) => (d === "in" ? "att-punch--in" : d === "out" ? "att-punch--out" : "att-punch--unk");
  const lbl = (d) => (d === "in" ? "IN" : d === "out" ? "OUT" : "?");

  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;
  const c = data?.counts || {};

  return (
    <div>
      <div className="att-toolbar">
        <input type="date" className="att-input" value={date} onChange={(e) => load(e.target.value)} />
        <button className="att-btn att-btn--ghost" onClick={() => load(date)}>Refresh</button>
        <span className="att-daylabel">{data?.date_label}</span>
        <span className="att-scope">{data?.in_scope} in scope</span>
      </div>

      <div className="att-cluster" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
        <div className="att-stat" style={{ "--rail": "#22c55e" }}>
          <span className="att-stat__n" style={{ color: "#15803d" }}>{c.in_building ?? 0}</span>
          <span className="att-stat__label">In building</span>
        </div>
        <div className="att-stat" style={{ "--rail": "#f97316" }}>
          <span className="att-stat__n" style={{ color: "#c2410c" }}>{c.left ?? 0}</span>
          <span className="att-stat__label">Left</span>
        </div>
        <div className="att-stat" style={{ "--rail": "#cbd0d6" }}>
          <span className="att-stat__n" style={{ color: "#6b7280" }}>{c.not_punched ?? 0}</span>
          <span className="att-stat__label">Not punched</span>
        </div>
      </div>

      {data?.is_today && (
        <div className="att-alert" style={{ background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1d4ed8", marginBottom: 14 }}>
          Live view — raw device punches, not yet scored. Today’s attendance is scored after the day ends.
        </div>
      )}

      <div className="att-card att-tablecard">
        <table className="att-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th className="num">First in</th>
              <th className="num">Last punch</th>
              <th>State</th>
              <th>Punches</th>
            </tr>
          </thead>
          <tbody>
            {(data?.rows || []).map((r) => (
              <tr key={r.employee_id} className={r.state === "not_punched" ? "is-mute" : ""}>
                <td data-label="Employee" className="att-name">{r.employee}</td>
                <td data-label="First in" className="num">{r.first}</td>
                <td data-label="Last punch" className="num">{r.last}</td>
                <td data-label="State">
                  {r.state === "in_building" && <span className="att-pill" style={{ color: "#15803d", background: "#dcfce7" }}>In building</span>}
                  {r.state === "left" && <span className="att-pill" style={{ color: "#c2410c", background: "#ffedd5" }}>Left</span>}
                  {r.state === "not_punched" && <span className="att-pill" style={{ color: "#6b7280", background: "#f1f2f4" }}>No punch</span>}
                </td>
                <td data-label="Punches">
                  {r.punches && r.punches.length > 0 ? (
                    <div className="att-punches">
                      {r.punches.map((p, i) => (
                        <span key={i} className={`att-punch ${cls(p.dir)}`}>
                          <span className="att-punch__k">{lbl(p.dir)}</span>{p.time}
                        </span>
                      ))}
                    </div>
                  ) : <span className="att-muted">—</span>}
                </td>
              </tr>
            ))}
            {(data?.rows || []).length === 0 && (
              <tr><td className="att-muted" colSpan={5}>No punches for this date yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ===================== Tab — Late report ===================== */
function LateReport({ onForbidden }) {
  const now = new Date();
  const [ym, setYm] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState({});
  const [q, setQ] = useState("");

  const load = useCallback(async (val) => {
    setLoading(true);
    const [y, m] = val.split("-");
    try { setData(await apiGet(`/late-report?year=${y}&month=${parseInt(m, 10)}`)); setOpen({}); }
    catch (e) {
      if (e.forbidden) return onForbidden();
      toast(e.message || "Failed to load late report", false);
    } finally { setLoading(false); }
  }, [onForbidden]);

  useEffect(() => { load(ym); }, []); // eslint-disable-line

  const exportXlsx = () => {
    const [y, m] = ym.split("-");
    window.open(`${API}/late-report?year=${y}&month=${parseInt(m, 10)}&format=xlsx`, "_blank");
  };

  const rows = useMemo(() => {
    const list = data?.rows || [];
    const needle = q.trim().toLowerCase();
    return needle ? list.filter((r) => r.employee.toLowerCase().includes(needle)) : list;
  }, [data, q]);

  const dash = <span style={{ color: "#b6bcc6" }}>–</span>;
  const val = (v) => (Number(v) > 0 ? <strong>{v}</strong> : dash);

  if (loading && !data) return <p className="att-muted att-pad">Loading…</p>;

  return (
    <div>
      <div className="att-toolbar">
        <input type="month" className="att-input" value={ym}
          onChange={(e) => { setYm(e.target.value); load(e.target.value); }} />
        <input className="att-input" placeholder="Search employee…" value={q}
          onChange={(e) => setQ(e.target.value)} style={{ minWidth: 220 }} />
        <button className="att-btn att-btn--ghost" onClick={exportXlsx}>Export Excel</button>
        <span className="att-daylabel">{data?.period}{loading ? " · loading…" : ""}</span>
      </div>

      <div className="att-card att-tablecard">
        <div className="att-ldscroll">
          <table className="att-table att-ldtable">
            <thead>
              <tr>
                <th style={{ width: 28 }}></th>
                <th>Employee</th>
                <th className="num">Morning late (days)</th>
                <th className="num">Morning late (min)</th>
                <th className="num">Early lunch (days)</th>
                <th className="num">Late after lunch (days)</th>
                <th className="num">Late after lunch (min)</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const isOpen = !!open[r.employee];
                return (
                  <React.Fragment key={r.employee}>
                    <tr className="att-scorerow"
                        onClick={() => setOpen((o) => ({ ...o, [r.employee]: !o[r.employee] }))}>
                      <td className="att-chevron">{isOpen ? "▾" : "▸"}</td>
                      <td data-label="Employee" className="att-name">{r.employee}</td>
                      <td data-label="Morning late (days)" className="num">{val(r.morning_days)}</td>
                      <td data-label="Morning late (min)" className="num">{val(r.morning_min)}</td>
                      <td data-label="Early lunch (days)" className="num">{val(r.early_days)}</td>
                      <td data-label="Late after lunch (days)" className="num">{val(r.after_days)}</td>
                      <td data-label="Late after lunch (min)" className="num">{val(r.after_min)}</td>
                    </tr>
                    {isOpen && (
                      <tr className="att-detailrow">
                        <td></td>
                        <td colSpan={6}>
                          <table className="att-table att-table--inner">
                            <thead>
                              <tr>{["Date", "Morning in", "Late (min)", "Early lunch", "Out", "Back", "Late after (min)"].map((h) =>
                                <th key={h} className={h === "Date" || h === "Early lunch" ? "" : "num"}>{h}</th>)}</tr>
                            </thead>
                            <tbody>
                              {r.days.map((d) => (
                                <tr key={d.date}>
                                  <td data-label="Date">{fmtDay(d.date)}</td>
                                  <td data-label="Morning in" className="num">{d.morning_in || dash}</td>
                                  <td data-label="Late (min)" className="num">{val(d.morning_late_min)}</td>
                                  <td data-label="Early lunch">{d.early || dash}</td>
                                  <td data-label="Out" className="num">{d.lunch_out || dash}</td>
                                  <td data-label="Back" className="num">{d.lunch_back || dash}</td>
                                  <td data-label="Late after (min)" className="num">{val(d.afternoon_late_min)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              {rows.length === 0 && (
                <tr><td className="att-muted" colSpan={7}>
                  {q ? `No employees match “${q}”.` : "No late arrivals or lunch issues for this period."}
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <p className="att-note" style={{ marginTop: 10 }}>
        Morning late = after 09:39 · Early lunch = break started before 13:00 · Late after lunch = still out at 14:00
        and returned after it. WFH days are left out.
      </p>
    </div>
  );
}


/* ===================== Shell ===================== */
export default function AttendanceAdmin() {
  useWindowSize(); // re-render on resize so the CSS card-collapse tracks correctly
  const [tab, setTab] = useState("day");
  const [forbidden, setForbidden] = useState(false);
  const [pending, setPending] = useState(null);
  const onForbidden = useCallback(() => setForbidden(true), []);
  const [currentUser, setCurrentUser] = useState(null);
  const [profilePic,  setProfilePic]  = useState(null);


  const tabs = [
    { key: "day", label: "Day dashboard" },
    // { key: "live", label: "Today (live)" },
    { key: "scorecard", label: "Monthly scorecard" },
    { key: "corrections", label: "Corrections queue", badge: pending },
    { key: "wfh", label: "Work from home" },
    { key: "leave", label: "Leave details" },
    { key: "late", label: "Late report" },      // ← add
    
  ];

  return (
      <>
      <div className="Admin-auditlogs-container">
        <TopBar />
        <div style={{ display: "flex", minHeight: "100vh", background: "#f0f2f5" }}>
          <div className="mdmanager-navbar" style={{ overflowX: "hidden" }}><Navbar /></div>

          <div className="att-root" style={{ flex: 1, minWidth: 0, padding: 24 }}>
            <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <style>{CSS}</style>

            {forbidden ? <Forbidden /> : (
              <div className="att-wrap">
                <h2 className="att-h1">Attendance</h2>
                <div className="att-tabs" role="tablist">
                  {tabs.map((t) => (
                    <button key={t.key} role="tab" aria-selected={tab === t.key}
                      className={`att-tab ${tab === t.key ? "is-on" : ""}`} onClick={() => setTab(t.key)}>
                      {t.label}
                      {t.badge ? <span className="att-tab__badge">{t.badge}</span> : null}
                    </button>
                  ))}
                </div>

                {tab === "day" && <DayDashboard onForbidden={onForbidden} />}
                {tab === "live" && <LiveToday onForbidden={onForbidden} />}
                {tab === "scorecard" && <MonthlyScorecard onForbidden={onForbidden} />}
                {tab === "corrections" && <CorrectionsQueue onForbidden={onForbidden} onCountChange={setPending} />}
                {tab === "wfh" && <WorkFromHome onForbidden={onForbidden} />}
                {tab === "leave" && <LeaveDetails onForbidden={onForbidden} />}
                {tab === "late" && <LateReport onForbidden={onForbidden} />}   {/* ← add */}
              </div>
            )}
          </div>
        </div>

        </div>
      </>
    );

  }

const CSS = `
.att-root{
  --navy:#101F40; --blue:#2563eb; --blue-ink:#1d4ed8;
  --ink:#1f2937; --sub:#6b7280; --line:#e8e4df; --line-2:#f0f2f5;
  --bg:#f0f2f5; --card:#fff;
  font-family:'DM Sans',system-ui,sans-serif; color:var(--ink);
}
.att-root *{box-sizing:border-box}
.att-wrap{max-width:1080px; margin:0 auto; padding:4px}
.att-h1{font-size:22px; font-weight:700; color:var(--navy); margin:0 0 16px}
.att-pad{padding:20px}
.att-muted{color:var(--sub); font-size:14px; padding:14px 4px}
.num{font-variant-numeric:tabular-nums}
.att-tabs{display:flex; gap:2px; border-bottom:1px solid var(--line); margin-bottom:20px; overflow-x:auto}
.att-tabs::-webkit-scrollbar{display:none}
.att-tab{appearance:none; border:0; background:none; padding:10px 16px; font:600 14px 'DM Sans';
  color:var(--sub); cursor:pointer; white-space:nowrap; border-bottom:2px solid transparent; margin-bottom:-1px;
  display:flex; align-items:center; gap:7px}
.att-tab:hover{color:var(--ink)}
.att-tab.is-on{color:var(--blue); border-bottom-color:var(--blue); font-weight:700}
.att-tab__badge{background:#c0392b; color:#fff; font-size:12px; font-weight:700; min-width:18px; height:18px;
  border-radius:9px; display:grid; place-items:center; padding:0 5px}
.att-toolbar{display:flex; gap:12px; align-items:center; flex-wrap:wrap; margin-bottom:16px}
.att-input{padding:8px 12px; border:1px solid var(--line); border-radius:9px; font:500 14px 'DM Sans'; color:var(--ink); background:#fff}
.att-daylabel{font-size:13px; color:var(--sub)}
.att-scope{margin-left:auto; font-size:13px; color:var(--sub)}
.att-note{font-size:12px; color:var(--sub)}
.att-cluster{display:grid; grid-template-columns:repeat(6,1fr); gap:10px; margin-bottom:16px}
.att-stat{background:var(--card); border:1px solid var(--line); border-radius:14px; padding:14px 16px;
  display:flex; flex-direction:column; gap:2px; position:relative; overflow:hidden}
.att-stat::before{content:""; position:absolute; left:0; top:12px; bottom:12px; width:3px; border-radius:3px; background:var(--rail)}
.att-stat.is-zero{opacity:.5}
.att-stat__n{font-size:24px; font-weight:700; line-height:1; font-variant-numeric:tabular-nums}
.att-stat__label{font-size:11px; font-weight:600; color:var(--sub); text-transform:uppercase; letter-spacing:.04em}
.att-chips{display:flex; gap:8px; flex-wrap:wrap; margin-bottom:14px}
.att-chip{appearance:none; cursor:pointer; border:1px solid var(--line); background:#fff; color:var(--sub);
  font:600 13px 'DM Sans'; padding:7px 14px; border-radius:20px; transition:.12s}
.att-chip:hover{border-color:#c9cdd3; color:var(--ink)}
.att-chip.is-on{background:var(--navy); border-color:var(--navy); color:#fff}
.att-card{background:var(--card); border:1px solid var(--line); border-radius:16px}
.att-tablecard{overflow:hidden}
.att-table{width:100%; border-collapse:collapse}
.att-table th{text-align:left; padding:11px 16px; background:#f7f8fa; border-bottom:1px solid var(--line);
  font:700 11px 'DM Sans'; text-transform:uppercase; letter-spacing:.05em; color:var(--sub); cursor:pointer; white-space:nowrap}
.att-table td{padding:12px 16px; border-bottom:1px solid var(--line-2); font-size:14px; color:var(--ink); vertical-align:middle}
.att-table tr:last-child td{border-bottom:0}
.att-name{font-weight:600}
.att-src{margin-left:6px; font-size:11px; color:var(--sub)}
.att-table tbody tr.is-exc{background:linear-gradient(90deg,color-mix(in srgb,var(--rail) 9%,#fff),#fff 55%); box-shadow:inset 3px 0 0 var(--rail)}
.att-table tbody tr.is-exc .att-name{font-weight:700}
.att-table tbody tr.is-mute{opacity:.6}
.att-pill{display:inline-block; padding:3px 10px; border-radius:999px; font-size:12px; font-weight:600; white-space:nowrap}
.att-alert{padding:14px 16px; border-radius:12px; font-weight:600}
.att-alert--bad{background:#fdecea; border:1px solid #e5a199; color:#c0392b}
.att-scorerow{cursor:pointer}
.att-scorerow:hover{background:#f7f8fa}
.att-chevron{color:var(--sub); width:28px}
.att-score{font-weight:700; font-size:15px; padding:2px 9px; border-radius:8px; font-variant-numeric:tabular-nums}
.att-score--good{color:#15803d; background:#dcfce7}
.att-score--mid{color:#b45309; background:#fef3c7}
.att-score--low{color:#b91c1c; background:#fee2e2}
.att-score--na{color:var(--sub); background:var(--line-2)}
.att-comp{display:flex; flex-wrap:wrap; gap:6px}
.att-comp__item{font-size:11.5px; color:var(--sub); background:var(--line-2); padding:2px 8px; border-radius:6px}
.att-detailrow > td{background:#fafbfc; padding:0 16px 12px}
.att-table--inner th{background:transparent; font-size:10.5px; padding:8px 10px}
.att-table--inner td{padding:7px 10px; font-size:13px}
/* Multi-punch drilldown */
.att-punchbadge{display:inline-block; margin-left:8px; font-size:10px; font-weight:600; color:#7c3aed;
  background:#f3e8ff; padding:1px 7px; border-radius:6px; vertical-align:middle}
.att-punchbadge--err{color:#b91c1c; background:#fee2e2}
.att-punchbadge--note{color:#b45309; background:#fef3c7}
.att-rowchev{color:var(--sub); font-size:12px; margin-left:4px}
.att-punchrow > td{padding:0 10px 8px !important; border-bottom:1px solid var(--line-2)}
.att-punchwrap{display:flex; flex-direction:column; gap:5px; padding:2px 0 4px}
.att-punches{display:flex; flex-wrap:wrap; gap:6px}
.att-punch{display:inline-flex; align-items:center; gap:5px; font-size:12px; font-variant-numeric:tabular-nums;
  padding:2px 9px; border-radius:7px; background:#f1f2f4; color:var(--ink)}
.att-punch__k{font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:.03em; color:var(--sub)}
.att-punch--in{background:#dcfce7} .att-punch--in .att-punch__k{color:#15803d}
.att-punch--out{background:#ffedd5} .att-punch--out .att-punch__k{color:#c2410c}
.att-punch--unk{background:#e5e7eb} .att-punch--unk .att-punch__k{color:#6b7280}
.att-punch--bad{outline:2px dashed #d97706; outline-offset:1px; font-weight:700}
.att-punchwarn{display:flex; flex-wrap:wrap; align-items:center; gap:8px; font-size:11.5px}
.att-punchwarn__mark{font-weight:700; padding:1px 8px; border-radius:6px; white-space:nowrap}
.att-punchwarn__mark--err{color:#b91c1c; background:#fee2e2}
.att-punchwarn__mark--note{color:#b45309; background:#fef3c7}
.att-punchwarn__list{color:var(--sub)}
.att-btn{appearance:none; cursor:pointer; font:600 13px 'DM Sans'; padding:8px 15px; border-radius:9px; border:1px solid var(--line); background:#fff; color:var(--ink); transition:.12s}
.att-btn:hover{border-color:#c9cdd3}
.att-btn:disabled{opacity:.55; cursor:default}
.att-btn--approve{background:#15803d; border-color:#15803d; color:#fff}
.att-btn--approve:hover{filter:brightness(.96)}
.att-btn--reject{color:#c0392b; border-color:#e3b4ad}
.att-btn--reject:hover{background:#fdeeee}
.att-corrlist{display:flex; flex-direction:column; gap:12px}
.att-corr{display:grid; grid-template-columns:180px 1fr auto; gap:18px; align-items:center; padding:16px 18px}
.att-corr.is-risk{border-color:#e5a199; background:#fdf6f5}
.att-corr__who{display:flex; flex-direction:column; gap:3px}
.att-corr__who strong{font-size:15px; color:var(--navy)}
.att-corr__date{font-size:12.5px; color:var(--sub)}
.att-corr__risk{font-size:11px; font-weight:700; color:#c0392b}
.att-corr__times{display:flex; align-items:center; gap:16px; flex-wrap:wrap}
.att-corr__col{display:flex; flex-direction:column; gap:2px}
.att-corr__col .k{font-size:10.5px; text-transform:uppercase; letter-spacing:.04em; color:var(--sub); font-weight:600}
.att-corr__col .v{font-size:14px; font-weight:600; font-variant-numeric:tabular-nums}
.att-corr__col .v--strike{text-decoration:line-through; color:var(--sub); font-weight:500}
.att-corr__col .v--reason{font-weight:500; color:var(--sub)}
.att-corr__arrow{color:var(--sub)}
.att-corr__actions{display:flex; gap:8px}
.att-empty{text-align:center; padding:52px 20px; color:var(--sub)}
.att-empty__mark{width:52px; height:52px; border-radius:50%; background:#dcfce7; color:#15803d;
  display:grid; place-items:center; font-size:24px; margin:0 auto 14px}
.att-forbidden{padding:24px; max-width:520px}
.att-forbidden h3{color:#c0392b; margin:0 0 6px}
.att-forbidden p{color:var(--sub); margin:0}

/* Leave details: scroll sideways instead of cutting columns off */
.att-ldscroll{overflow-x:auto; -webkit-overflow-scrolling:touch}
.att-ldtable{min-width:900px}
.att-ldtable th, .att-ldtable td{white-space:nowrap}
.att-ldtable td.att-name{white-space:normal; min-width:180px}
.att-ldtable .att-src{display:block; margin:2px 0 0}
@media (max-width:1100px){
  .att-ldtable th, .att-ldtable td{padding:10px 10px}
  .att-ldtable{font-size:13px}
}

/* Work from home */
.att-wfhform{display:grid; grid-template-columns:minmax(260px,1fr) minmax(280px,1fr); gap:24px; padding:18px 20px}
.att-field{display:flex; flex-direction:column; gap:8px; min-width:0}
.att-field--emp select.att-input{padding:4px; height:auto}
.att-field--emp select.att-input option{padding:6px 8px; border-radius:6px}
.att-label{font-size:13px; font-weight:700; color:var(--navy)}
.att-sub{display:flex; flex-direction:column; gap:4px; font-size:12px; font-weight:600; color:var(--sub)}
.att-hint{font-size:12px; color:var(--sub)}
.att-hint--warn{color:#b45309}
.att-daterow{display:flex; gap:12px; flex-wrap:wrap}
.att-seg{display:inline-flex; border:1px solid var(--line); border-radius:10px; padding:3px; background:#f7f8fa; align-self:flex-start}
.att-seg__btn{appearance:none; border:0; background:none; cursor:pointer; font:600 13px 'DM Sans'; color:var(--sub); padding:6px 14px; border-radius:7px}
.att-seg__btn.is-on{background:#fff; color:var(--blue-ink); box-shadow:0 0 0 1px var(--line)}
.att-btn--primary{background:var(--navy); border-color:var(--navy); color:#fff; margin-top:6px}
.att-btn--primary:hover{filter:brightness(1.15)}
.att-formerr{font-size:13px; font-weight:600; color:#b91c1c; background:#fee2e2; padding:8px 12px; border-radius:9px}
.att-wfhreason{color:var(--sub); max-width:260px}
.att-root :is(.att-btn,.att-chip,.att-tab,.att-seg__btn,.att-input):focus-visible{outline:2px solid var(--blue); outline-offset:2px}
@media (max-width:640px){
  .att-wfhform{grid-template-columns:1fr}
}
@media (max-width:640px){
  .att-cluster{grid-template-columns:repeat(3,1fr)}
  .att-scope{margin-left:0}
  .att-table thead{display:none}
  .att-table, .att-table tbody, .att-table tr, .att-table td{display:block; width:100%}
  .att-table tr{border-bottom:1px solid var(--line); padding:12px 14px}
  .att-table tr:last-child{border-bottom:0}
  .att-table td{border:0; padding:5px 0; display:flex; justify-content:space-between; align-items:center; gap:12px}
  .att-table td::before{content:attr(data-label); font:600 11px 'DM Sans'; text-transform:uppercase; letter-spacing:.04em; color:var(--sub)}
  .att-table td.att-name::before{content:""}
  .att-table td.att-name{font-size:15px}
  .att-table tbody tr.is-exc{box-shadow:inset 3px 0 0 var(--rail)}
  .att-detailrow > td{padding:0}
  .att-table--inner tr{padding:8px 0; border-bottom:1px solid var(--line-2)}
  .att-punchrow > td{padding:4px 0 !important}
  .att-punches{padding:0}
  .att-ldtable{min-width:0}
  .att-ldtable th, .att-ldtable td{white-space:normal}
  .att-ldtable td.att-name{display:block}
  .att-ldtable td{justify-content:flex-start; gap:4px; background:transparent !important}
  .att-ldtable td::before{margin-right:auto}
  .att-corr{grid-template-columns:1fr}
  .att-corr__actions .att-btn{flex:1}
}
@media (max-width:400px){ .att-cluster{grid-template-columns:repeat(2,1fr)} }
@media (prefers-reduced-motion:reduce){ .att-root *{transition:none!important} }
`;
